import { Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ClassificationTypeService, DocRole, WarehouseDto } from '@digiwall/goliath-core/proxy';
import { BaseStockDocDetailHelperService } from '../../../base-docs/detail/base-stock-doc-detail';
import {
  CreateStockDocTransferDto,
  DayBookService,
  StockDocDefaultValueDto,
  StockDocTransferDto,
  StockDocTransferService,
} from '@digiwall/goliath-documents/proxy';
import {
  StockDocDetailComponent,
  StockDocDetailComponentImports,
  StockDocDetailComponentProviders,
} from '../../stock-doc-detail.component';
import { SubscriptionService, LocalizationService, ConfigStateService } from '@abp/ng.core';
import { ToasterService, ConfirmationService } from '@abp/ng.theme.shared';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DeactivatableComponentService } from '@digiwall/core';
import { BreadcrumbService } from 'xng-breadcrumb';
import { DocTemplateService } from '../../../base-docs/detail/doc-template-selection/doc-template.service';
import StockDocTransferLinesEditorComponent from './stock-doc-transfer-lines/stock-doc-transfer-lines-editor.component';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'document-stock-doc-transfer-detail',
  templateUrl: './stock-doc-transfer-detail.component.html',
  styleUrl: './stock-doc-transfer-detail.component.scss',
  providers: [BaseStockDocDetailHelperService, ...StockDocDetailComponentProviders],
  imports: [StockDocTransferLinesEditorComponent, ...StockDocDetailComponentImports],
})
export class StockDocTransferDetailComponent
  extends StockDocDetailComponent<
    StockDocTransferService,
    StockDocTransferDto,
    CreateStockDocTransferDto,
    StockDocDefaultValueDto
  >
  implements OnInit, OnDestroy
{
  @ViewChild('stockDocLineGrid')
  stockDocLineGrid!: StockDocTransferLinesEditorComponent;

  warehousesToTransfer: WarehouseDto[];

  constructor(
    route: ActivatedRoute,
    router: Router,
    subscriptionService: SubscriptionService,
    docService: StockDocTransferService,
    formBuilder: FormBuilder,
    toastService: ToasterService,
    breadcrumbService: BreadcrumbService,
    dayBookService: DayBookService,
    localizationService: LocalizationService,
    classificationTypeService: ClassificationTypeService,
    docTemplateService: DocTemplateService,
    injector: Injector,
    config: ConfigStateService,
    confirmationService: ConfirmationService,
    deactivableComponentService: DeactivatableComponentService,
  ) {
    super(
      route,
      router,
      subscriptionService,
      docService,
      formBuilder,
      toastService,
      breadcrumbService,
      dayBookService,
      localizationService,
      classificationTypeService,
      docTemplateService,
      injector,
      config,
      confirmationService,
      deactivableComponentService,
    );
  }

  override get docRole() {
    return DocRole.StockDocTransfer;
  }

  get isSerialEntry() {
    return this.router.url.split('/').includes('stock-entry');
  }

  override save() {
    if (!this.stockDocLineGrid) {
      super.save();
      return;
    }

    this.stockDocLineGrid.beforeSaveDocument().subscribeOnce(() => {
      super.save();
    });
  }
  override get formModel() {
    const formModel = super.formModel;
    return this.isSerialEntry
      ? Object.assign({}, formModel, {
          copyLineData: [false],
          printLabel: [false],
          siteToId: [null],
        })
      : Object.assign({}, formModel, {
          siteToId: [null],
        });
  }

  protected override getEntityCallback(): void {
    super.getEntityCallback();
    this.setWarehousesToTransfer(this.entity.siteToId);
  }

  protected override initFormObservers() {
    super.initFormObservers();
    this.form
      .get('siteToId')
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(siteToId => {
        this.setWarehousesToTransfer(siteToId);
      });

    this.form
      .get('companySiteId')
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(companySiteId => {
        if (this.form.get('siteToId').value == null) {
          this.form.get('siteToId').setValue(companySiteId);
        }
      });
  }

  override setDefaultValue(response: StockDocDefaultValueDto) {
    super.setDefaultValue(response);
    if (this.isSerialEntry) {
      this.form.get('copyLineData').setValue(true);
      this.form.get('printLabel').setValue(true);
    }
  }

  private setWarehousesToTransfer(siteToId: string) {
    this.warehousesToTransfer = this.wareHouseStore
      .entities()
      .filter(wh => wh.companySiteId == siteToId);

    if (siteToId == null) {
      this.form.get('warehouseToId').setValue(null);
    }
  }
}
